import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { InviteUser, Organization, OrgMemberUpdate, RestResponse, User } from "src/app/model";
import { ApiHeaders } from "src/app/providers";

@Injectable()
export class OrgProvider {

    constructor(private http: HttpClient) { }

    removeUserFromOrgForOA(orgId: string, userId: string): Observable<RestResponse> {
        return this.http.delete<RestResponse>(`/api/org/${orgId}/${userId}`, ApiHeaders.getOptions());
    }

    getUserRolesForOA(query: string): Observable<RestResponse> {
        return this.http.get<RestResponse>(`/api/org/role/list?query=${query}`, ApiHeaders.getOptions());
    }

    getOrganizationDetailsForOA(orgId: string): Observable<RestResponse> {
        return this.http.get<RestResponse>(`/api/org/${orgId}`, ApiHeaders.getOptions());
    }

    addUserInOrganizationForOA(orgId: string, obj: InviteUser): Observable<RestResponse> {
        return this.http.post<RestResponse>(`/api/org/adduser/${orgId}`, obj, ApiHeaders.getOptions());
    }

    saveUserDetailsForOA(user: OrgMemberUpdate): Observable<RestResponse> {
        return this.http.post<RestResponse>(`/api/org/user`, user, ApiHeaders.getOptions());
    }

    saveOrganizationDetailsForOA(org: Organization): Observable<RestResponse> {
        return this.http.post<RestResponse>(`/api/org`, org, ApiHeaders.getOptions());
    }

    getOrgUserListForOA(page: number = 1, size: number = 20, query: string = ''): Observable<RestResponse> {
        return this.http.get<RestResponse>(`/api/org/users?` +
            `page=${page}` +
            `&size=${size}` +
            `&query=${query}`, ApiHeaders.getOptions());
    }

}
